import StatusBadge from "../StatusBadge/StatusBadge";

const DelegationItem = ({ member }) => {
    return (
        <>
            <style>
                {`
                .delegation-item {
                display: flex;
                justify-content: space-between;
                align-items: center;
                }

                .delegation-user {
                display: flex;
                align-items: center;
                gap: 16px;
                color: var( --color-background);
                font-weight: 500;
                }

                .delegation-user img {
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
                }
                `}
            </style>
            <div className="delegation-item">
                <div className="delegation-user">
                    <img src={member.profile_picture} alt={member.username} />
                    <span>{member.username}</span>
                </div>

                <StatusBadge status={member.public_status} />
            </div>
        </>
    );
};

export default DelegationItem;
